import React, { useState, useEffect } from "react";
import { Grid, Box } from "@mui/material";
import { useDepthChart } from "../../../../contexts/DepthChartContext";
import { useLogger } from "../../../../contexts/LoggerContext";
import { PlayerSelection } from "../Components/PlayerSelection";
import { RosterPlayer } from "../../../../types/LogTypes";
import { useRoster } from "../../../../contexts/RosterContext";
import { GainLossInput } from "../Components/GainLossInput";

export const OffenseRunLog = () => {
  const [gainLoss, setGainLoss] = useState(0);
  const [selectedBallCarrier, setSelectedBallCarrier] =
    useState<RosterPlayer | null>(null);
  const [jerseyNumber, setJerseyNumber] = useState<string>("");
  const { ballCarriers } = useDepthChart();
  const { rosterPlayers } = useRoster();
  const { setCurrentPlayLog, clearSelections } = useLogger();

  const findBallCarrier = (jerseyNumber: string) => {
    return rosterPlayers.find(
      (player) => player.jersey_number?.toString() === jerseyNumber
    );
  };

  const handleJerseyNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    if (value === "" || (parseInt(value) >= 0 && parseInt(value) <= 99)) {
      setJerseyNumber(value);
      const player = findBallCarrier(value);
      console.log("player", player);
      if (player) {
        setSelectedBallCarrier(player);
      }
    }
  };

  const handleBallCarrierSelection = (player: RosterPlayer) => {
    setSelectedBallCarrier(player);
    setJerseyNumber(player.jersey_number?.toString() || "");
  };

  useEffect(() => {
    if (selectedBallCarrier) {
      setCurrentPlayLog({
        rusher_roster_player: selectedBallCarrier,
        gain_loss: gainLoss,
      });
    }
  }, [selectedBallCarrier, gainLoss]);

  useEffect(() => {
    if (clearSelections) {
      setSelectedBallCarrier(null);
      setJerseyNumber("");
      setGainLoss(0);
    }
  }, [clearSelections]);

  return (
    <Box>
      <Grid container>
        {/* Ball Carrier */}
        <Grid item xs={8}>
          <PlayerSelection
            title="Ball Carrier"
            players={ballCarriers}
            selectedPlayer={selectedBallCarrier}
            jerseyNumber={jerseyNumber}
            maxDisplayedPlayers={8}
            handlePlayerSelection={handleBallCarrierSelection}
            handleJerseyNumberChange={handleJerseyNumberChange}
          />
        </Grid>
        {/* Gain/Loss */}
        <Grid item xs={4}>
          <GainLossInput
            value={gainLoss}
            onChange={setGainLoss}
            label="Gain/Loss"
          />
        </Grid>
      </Grid>
    </Box>
  );
};
